import { Application as AppEnum } from '@fides/fides-react-components';
import { Logger } from 'core/services';
import { ENV } from 'core/consts';
import 'core/i18n';

export const Log: Logger = new Logger(ENV.ENVIRONMENT);

export const DefaultApps: [string, AppEnum, (url: string) => string | undefined][] = [];
DefaultApps.push(
  ['ARSApiUrl', AppEnum.ARSWEB, (url) => `${url}/arsweb`],
  ['EFTApiUrl', AppEnum.EFTWEB, (url) => `${url}/eftweb`],
  ['CPSApiUrl', AppEnum.CPSWEB, (url) => `${url}/cpsweb`],
  ['DLCApiUrl', AppEnum.DLCWEB, (url) => `${url}/download-center`],
  ['PortalApiUrl', AppEnum.PORTAL, (url) => `${url.replace(/\/portal$/, '')}/fidesportal`]
);
